import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'
import {UIDLeaderboardController} from '../../../ui_leaderboard/UIDLeaderboardController.ts'

export class UIDLeaderboardSceneController {
    private readonly sidebarController: UISidebarController
    private readonly leaderboardController: UIDLeaderboardController
    private readonly leaderboardSceneContainerDiv: HTMLDivElement
    private hasFetched: boolean

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.leaderboardController = new UIDLeaderboardController()
        this.leaderboardSceneContainerDiv = document.getElementById('scene_discord_leaderboard_container') as HTMLDivElement
        this.hasFetched = false
    }

    hide() {
        this.leaderboardSceneContainerDiv.classList.add('hidden')
    }

    async show() {
        this.leaderboardSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.activateLeaderboard()

        if(this.hasFetched) return

        await this.leaderboardController.fetchStickyRowData()
        this.hasFetched = true
        this.leaderboardController.showChangeRegionIncentivePopup()
    }
}
